/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for splitDisplay. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="splitDisplay"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="inline"/&gt; &lt;enumeration value="folder"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SplitDisplay extends Enum{

	enumValue = null;

	static  INLINE = SplitDisplay.newLiteral("inline");

	static  FOLDER = SplitDisplay.newLiteral("folder");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < SplitDisplay.values().length); ++i) {
			if (SplitDisplay.values()[i].enumValue == v) {
				return SplitDisplay.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("SplitDisplay" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SplitDisplay.js